import {
  EuiBreadcrumb,
  EuiHeader,
  EuiHeaderLogo,
  EuiHeaderSections,
  EuiPageHeader,
} from "@elastic/eui";
import { AutonubilSvg } from "../../assets";
import { Avatar } from "./controls";
import { QuestionnaireHeader } from "src/questionnaires";
import { CreateQuestionnaire } from "src/questionnaires/create";
import { useEffect, useMemo, useState } from "react";
import { ButtonUserFeedback } from "src/feedback";
import { useLocation, useNavigate } from "react-router";
import { useAnketaAuth } from "src/auth";
import { Catalog } from "anketa-core/types";
import { ThemeToggle } from "src/theme";

export const Header = ({
  breadcrumbs,
  navIsOpen,
  setNavIsOpen,
  updateCatalog,
}: {
  breadcrumbs: EuiBreadcrumb[];
  navIsOpen: boolean;
  setNavIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  updateCatalog: (c: Catalog) => void;
}): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();

  const { user } = useAnketaAuth();

  const [modalIsVisible, setModalIsVisible] = useState<boolean>(false);
  const closeModal = () => {
    setModalIsVisible(false);
  };

  const currentView = useMemo<string>(() => {
    return location.pathname.split("/")[1];
  }, [location]);

  const sections: EuiHeaderSections[] = [
    {
      items: [
        <EuiHeaderLogo
          iconType={AutonubilSvg}
          onClick={() => {
            setNavIsOpen((isOpen) => !isOpen);
            localStorage.setItem(
              "EuiCollapsibleNavExample--isDocked",
              JSON.stringify(!navIsOpen),
            );
          }}
          aria-label="Navigate to home page"
        />,
      ],
      borders: "right",
      breadcrumbs: breadcrumbs,
      breadcrumbProps: {
        "aria-label": "Navigate Back to the Homepage",
      },
    },
    {
      // Drop falsy entries: EuiHeader marks every `items[n]` as required, so a
      // bare `user && <X/>` (=> undefined) or `cond && <Y/>` (=> false) trips a
      // prop-type warning. filter(Boolean) keeps only the rendered nodes.
      items: [
        user && <ButtonUserFeedback />,
        currentView === "questionnaires" && (
          <QuestionnaireHeader setModalIsVisible={setModalIsVisible} />
        ),
      ].filter(Boolean),
      borders: "left",
    },

    {
      items: [<ThemeToggle />, <Avatar />],
      borders: "left",
    },
  ];

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/home");
    }
    localStorage.setItem("anketa.nav.side.isOpen", navIsOpen.toString());
  }, [navIsOpen]);

  return (
    <EuiPageHeader
      style={{
        position: "sticky",
        top: "15px",
        zIndex: "1000",
      }}
    >
      <EuiHeader
        sections={sections}
        style={{
          width: "100%",
        }}
      />
      {modalIsVisible && currentView === "questionnaires" && (
        <CreateQuestionnaire
          onClose={closeModal}
          updateCatalog={updateCatalog}
        />
      )}
    </EuiPageHeader>
  );
};
